import { PostBox } from 'pages/home/Home.style';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getJobPostById } from 'redux/features/PostJobSlice';
import { JobDetailView } from './JobPosts.style';
import Preview from './Preview';
import { BrandIconSpinner } from 'components';
import {
  getCountryList,
  getJobTypeList,
  getWorkTypeList,
} from 'redux/features/DropDownSlice';

import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import { Helmet } from 'react-helmet';
import { stripHtmlTags } from 'utils/helper';

export default function JobdetailView() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  const [loading, setLoading] = useState(true);
  const [jobNoFound, setJobNoFound] = useState(false);
  const [jobDetailview, setJobDetailview] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    jobList?.length === 0 && dispatch(getJobTypeList());
    workTypeList?.length === 0 && dispatch(getWorkTypeList());
    countryList?.length === 0 && dispatch(getCountryList());
    id &&
      dispatch(getJobPostById(id))
        .then((res) => {
          setLoading(false);
          if (res) {
            setJobDetailview(res);
          } else {
            setJobNoFound(true);
          }
        })
        .catch(() => {
          setLoading(false);
          setJobNoFound(true);
        });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>
          {jobDetailview?.jobTitle
            ? `${jobDetailview?.jobTitle?.length > 50
              ? jobDetailview?.jobTitle.slice(0, 50) + '...'
              : jobDetailview?.jobTitle} | WafyNet`
            : 'Job Details | WafyNet'}
        </title>
        <meta
          name="description"
          content={
            jobDetailview?.jobDescription
              ? stripHtmlTags(jobDetailview.jobDescription).slice(0, 150)
              : "View detailed job information, responsibilities, and apply easily through WafyNet."
          }
        />
      </Helmet>
      <JobDetailView>
        <PostBox>
          {jobNoFound && (
            <div className="no-data-found">
              <NoDataFound />
              <div>Job not found or Job Expired</div>
            </div>
          )}
          {loading ? (
            <BrandIconSpinner loading={loading} />
          ) : (
            !jobNoFound && <Preview state={jobDetailview} disableAction isApply={true} />
          )}
        </PostBox>
      </JobDetailView>
    </>
  );
}
